import { mapIdsToRows } from './use-computed-selected-row-ids.mapper';

const resolveNextIds = (updater: React.SetStateAction<Set<string>>, prevIds: Set<string>): Set<string> =>
    typeof updater === 'function' ? updater(prevIds) : updater;

export const updateSelectedRowsFromIds =
    <T extends { id: string }>(setSelectedRows: React.Dispatch<React.SetStateAction<T[]>>, tableData?: T[]) =>
    (updater: React.SetStateAction<Set<string>>) => {
        setSelectedRows((prevRows) => {
            const prevIds = new Set(prevRows?.map((r) => r.id));
            const nextIds = resolveNextIds(updater, prevIds);

            return mapIdsToRows(nextIds, tableData);
        });
    };
